import { Button, ButtonGroup, Intent } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { DIALOG_SIZE, POST_STATUS } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { actions } from "src/modules/pe-landing-module/data/actions"
import { GET_WEBSITE_TAGS } from "src/modules/pe-landing-module/data/actionTypes"
import { ILink } from "src/modules/pe-landing-module/data/interfaces"
import { LANDING_SCALAR } from "src/modules/pe-landing-module/data/landin_scalars"
import CategoryIdScalar from "src/modules/pe-landing-module/widgets/composite/CategoryIdScalar"
import { LoaderMinimal } from "src/stories/Loading"
import { LINK_POST_TYPES } from "../../../primitive/LinksFeedPrimitive"


/* Protopia Ecosystem component */
export interface ISingleLinkDialogProps {
    value?: ILink
    isOpen: boolean
    onAdd: ( data: ILink) => void
    onClose: () => void
} 
export const SingleLinkDialog = ({isOpen, ...props}:ISingleLinkDialogProps) : JSX.Element => { 
    const [value, setValue] = useState<ILink>(props.value || {} as ILink )
    const [isLoading, setIsLoading] = useState<boolean>( false )

    useEffect(() => {
        setValue( props.value || {} as ILink )
    }, [ props.value ])

    const onChange = (val: any, field: string, dop: any="") => {
        setValue({
            ...value,
            [field]: val
        })
    }
    

    const onAdd = () => {
        props.onAdd( value )
    }

    return <ScalableDialog
        dialogSize={DIALOG_SIZE.NORMAL}
        onClose={props.onClose}
        isOpen={isOpen}
    >
        <div className="my-4 p-5 container">
            <LinkEditForm value={value} isLoading={isLoading} onChange={onChange} setIsLoading={setIsLoading} setValue={setValue} />
        </div>
        <ButtonGroup fill size="large">
            <Button intent={ Intent.SUCCESS } fill onClick={ onAdd } disabled={ !value.url }>
                { __( !!props.value ? "Edit link" : "Add new link" ) }
            </Button>
            <Button fill={ false } intent={ Intent.DANGER } icon="cross" onClick={ props.onClose } />
        </ButtonGroup>
    </ScalableDialog>
}

export interface ILinkEditFormProps {
    value: ILink
    isLoading: boolean
    onChange : ( val: any, field: string, dop: any ) => void 
    setIsLoading?: (bool: boolean) => void
    setValue?: (data:ILink) => void
}
export const LinkEditForm = ({ value, isLoading, onChange, setIsLoading, setValue, ...props }: ILinkEditFormProps) : JSX.Element => {
    const onChangeURL = (val: any, field: string, dop: any="") => {
        onChange(val, field, dop)
        if(!!val) {
            if( !!setIsLoading ) setIsLoading( true )
            actions( GET_WEBSITE_TAGS, { url: val })
                .then((response: any) => {  
                    if( !!setIsLoading ) setIsLoading( false )    
                    if(!!setValue) setValue({
                        ...value,
                        [field]: val,
                        title: response.title,
                        description: response.description || response.post_content,
                        post_content: response.description || response.post_content,
                        keywords: response.keywords,
                        image: response.image,
                        status: POST_STATUS.PUBLISH,
                    })     
                })
        }
    }
    return <>
        <div className="d-flex align-items-center">
            <div className="w-100 flex-grow-100">
                <FieldInput
                    type={SCALAR_TYPES.STRING}
                    value={value.url}
                    onChange={onChangeURL}
                    title={__("URL")}
                    field="url"
                    editable
                />
            </div>
            {
                isLoading && <LoaderMinimal />
            }
        </div>
        <FieldInput
            type={SCALAR_TYPES.STRING}
            value={ value.title }
            onChange={ onChange }
            title={__( "Title" )}
            field="title"
            editable
        />
        <FieldInput
            type={SCALAR_TYPES.MEDIA}
            value={ value.image }
            onChange={ onChange }
            title={__( "Image" )}
            field="image"
            editable
        />
        <FieldInput
            type={ SCALAR_TYPES.STRING }
            value={ value.post_content }
            onChange={ onChange }
            title={ __( "Description" ) }
            field="post_content"
            editable
        />
        <FieldInput
            type={ SCALAR_TYPES.TAGS }
            values={ LINK_POST_TYPES }
            value={ value.status }
            onChange={ onChange }
            title={ __( "Status" ) }
            default={ POST_STATUS.PUBLISH }
            field="status"
            editable
        />
        <CategoryIdScalar
            title={ __( "Categories" ) }
            isAlwaysOpen
            isNotCard={false}
            dataSection="Section"
            dataName={ LANDING_SCALAR.CATEGORY_ID }
            type={ LANDING_SCALAR.CATEGORY_ID }
            value={ value.categoryId } 
            field="categoryId"
            onChange={onChange}
            sectionId={ "-1" }
            editable
        />
    </>
}